<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="20" height="20" rx="10" fill="#346AE1" fill-opacity="0.2"/>
<circle cx="10" cy="10" r="5.3125" fill="#346AE1" stroke="white" stroke-width="0.625"/>
</svg>
